// 系统维护模块请求地址
export const xtwhUrls = {
    // 获取学校信息
    getSchoolInfo: '/feather/getSchoolInfo',
    // 获取二级菜单
    getTwoMenu: '/feather/permission/getTwoMenu',
    // 查询院系信息
    queryYxInfo: '/feather/zzjg/getAllYxxxs',
    // 个人设置
    userConfig: {
        // 查询用户信息
        getUserDetail: '/feather/user/getUserDetail',
        // 修改登录用户的信息
        updUserDetail: '/feather/user/updUserDetail',
        // 修改密码
        updPass: '/feather/user/updPass',
        // 修改个人头像
        updAvatar: '/feather/user/updAvatar',
    },

    //  用户角色 - 用户信息
    userInfo: {
        /*
        &根据姓名查询用户信息
        *name 	string 	否 	姓名
        *ghhxh 	string 	否 	工号或学号
        *yhlxOpenid 	string 	否 	用户类型
        *page 	integer 	否(默认查询第一页) 	页码
        *rows 	integer 	否(默认每页显示10条) 	每页显示信息条数
        */
        queryUserInfo: '/feather/user/getUsers',
    },

    //  用户角色 - 角色信息
    roleInfo: {
        /*
         &新增修改角色
         *name 	string 	是 	权限名称
         *openid 	string 	否 	权限的开放id
         *description 	string 	否 	描述
         *type 	integer 	否 	角色的类型，0教师，1学生
         */
        addOrEdit: '/feather/modules/saveModule',

        /*
        &删除角色
        *openid 	string 	是 	权限的开放id
        */
        delRole: '/feather/modules/delModule',

        /*
        &分页查询角色信息
        *page 	integer 	否(默认查询第一页) 	页码
        *rows 	integer 	否(默认每页显示10条) 	每页显示信息条数
        */
        pagingQueryRoleInfo: '/feather/modules/getModules',
        // 根据名称查询角色信息
        getModulesByName: '/feather/modules/getByName',
    },
    // 用户角色 - 用户角色
    userRole: {
        /*
         &根据角色查询教师信息
         *qxmkOpenid 	string 	是 	用户角色id
         *jsName 	string 	否 	 	教师姓名
         */
        queryTeacherInfo: '/feather/teacherQxmk/getJsByQxmk',

        /*
        &添加教师的角色信息
        *jsOpenid 	string 	是   教师的开放id(多个教师用逗号分隔，教师和角色不能同时有多个)
        *qxmkOpenids 	string 	是 	角色的开放id(多个角色用逗号分隔，教师和角色不能同时有多个)
        */
        addTeacherRoleInfo: '/feather/teacherQxmk/save',

        /*
        &删除教师的角色信息
        *jsOpenid 	string 	是   教师的开放id(多个教师用逗号分隔，教师和角色不能同时有多个)
        *qxmkOpenid 	string 	是 	角色的开放id(多个角色用逗号分隔，教师和角色不能同时有多个)
        */
        delTeacherRoleInfo: '/feather/teacherQxmk/delete',
    },
    // 权限分配 - 权限维护
    qxwh: {
        // 查询权限信息
        queryQxInfo: '/feather/permission/getPermissions',
        // 新增或修改权限动作信息
        addOrEditQx: '/feather/permission/savePermission',
        // 根据id删除权限动作信息
        delQxUrlInfo: '/feather/permission/delPermission',
        // 获取所有权限父对象
        getAllQxfdx: '/feather/permission/getTwo',
        // 启用禁用
        enable: '/feather/permission/updEnable',
        // 获取所有动作响应类型
        getAllDzXyType: '/feather/permission/getXylx',
        // 根据权限类型查询权限信息集合
        getFPermissions: '/feather/permission/getFPermissions',
        // 获取所有权限树
        getAllPermissionTree: '/feather/permission/getAll',
        // 获取权限树(模糊查询)
        getAllTree: '/feather/permission/getAllTree',
        // 根据id查询
        getById: '/feather/permission/getById',
        // 根据角色id查询权限树
        getRoleQxTree: '/feather/permission/getIdsByYhjsxx',
        // role权限保存
        saveRoleQxTree: '/feather/qxmkQxdz/save',
        // 获取所有部门列表
        getAlldepartment: '/feather/zzjg/getZzjgName',
        // 部门权限保存
        saveBmQxTree: '/feather/zzjgQxdz/save',
        // 根据部门id查询权限树
        getDepartmentQxTree: '/feather/permission/getIdsByZzjg',
        // 查询部门列表（教师权限最左侧列表）
        getAllDePartmentList: '/feather/zzjg/getAll',
        // 获取教师列表
        getAllTeacherList: '/feather/teacher/getAll',
        // 获取教师列表
        getZzjgTeacherList: '/feather/teacherZzjg/getJsByZzjg',
        // 查询教师角色列表（教师权限最右侧）
        getTeacherRoleList: '/feather/teacherQxmk/getQxmkByJs',
        // 保存教师权限
        saveTeacherQx: '/feather/teacherQxdz/save',
        // 根据教师查询权限id集合
        getQxIdsByTeacher: '/feather/permission/getIdsByTeacher',
        // 删除教师角色
        deleteTeacherRole: '/feather/teacherQxmk/delete',
        // 保存教师角色添加
        saveTeacherRole: '/feather/teacherQxmk/save',
    },
    mkpz: {
        // 分页查询模块配置信息
        findPage: '/feather/modleConfig/getModleConfigs',
        save: '/feather/modleConfig/save',
    },
    // 系统维护 - app应用管理
    app: {
        // 分页查询app应用
        pagingQueryApp: '/feather/menuinfo/findPage',
        // 启用/禁用app应用
        enableApp: '/feather/menuinfo/updEnable',
        // 下载APP应用图标
        downLoadIcon: '/feather/menuinfo/down_icon',
        // 新增修改app应用
        addOrEditApp: '/feather/menuinfo/save',
        // 保存角色应用信息
        saveAppRole: '/feather/role/save',
        // 分页查询角色应用信息
        pagingQueryRoleAppInfo: '/feather/role/findPage',
        // 删除角色应用信息
        deleteRoleAppInfo: '/feather/role/delByIds',
        // 保存部门应用信息
        saveOrAddDeptApp: '/feather/deptinfo/save',
        // 分页查询部门应用信息
        pagingQueryBmAppInfo: '/feather/deptinfo/findPage',
        // 删除部门应用信息
        deleteBmAppInfo: '/feather/deptinfo/delByIds',
        // 保存教师应用信息
        saveOrEditTeacherAppInfo: '/feather/userinfo/save',
        // 分页查询教师应用信息
        pagingQueryTeacherAppInfo: '/feather/userinfo/findPage',
        // 删除教师应用信息
        deleteTeacherAppInfo: '/feather/userinfo/delByIds',
    },
    // app信息配置apk上传等url
    apk: {
        // 基础信息
        getProjectInfo: '/feather/sysConfig/getProjectInfo',
        updateValue: '/feather/sysConfig/updateConfig',

        // apk上传
        findPage: '/feather/apk/queryListForPage',
        addUrl: '/feather/apk/add',
        update: '/feather/apk/update',
        delete: '/feather/apk/delete',
    },
    // 其他模块管理
    otherModle: {
        // 查询用户的其他模块信息集合
        getTeacherOtherModles: '/feather/otherModle/getTeacherOtherModles',
        // 用户访问其他模块
        openOtherModle: '/feather/otherModle/openOtherModle',
        // 保存其他模块
        save: '/feather/otherModle/save',
        // 启用或禁用其他模块
        updEnable: '/feather/otherModle/updEnable',
        // 分页查询其他模块
        findPage: '/feather/otherModle/findPage',
    },
    // 部门其他模块
    deptOtherModle: {
        // 保存部门其他模块配置
        save: '/feather/deptOtherModle/save',
        // 删除部门其他模块配置
        delById: '/feather/deptOtherModle/delById',
        // 分页查询部门其他模块配置
        findPage: '/feather/deptOtherModle/findPage',
    },
    // 角色其他模块
    roleOtherModle: {
        // 保存角色其他模块配置
        save: '/feather/roleOtherModle/save',
        // 删除角色其他模块配置
        delById: '/feather/roleOtherModle/delById',
        // 分页查询角色其他模块配置
        findPage: '/feather/roleOtherModle/findPage',
    },
    // 教师其他模块
    teacherOtherModle: {
        // 保存教师其他模块配置
        save: '/feather/teacherOtherModle/save',
        // 删除教师其他模块配置
        delById: '/feather/teacherOtherModle/delById',
        // 分页查询教师其他模块配置
        findPage: '/feather/teacherOtherModle/findPage',
    },
    // 负责人管理
    fzrgl: {
        // 查询所有部门列表（树形表格）
        queryAllBmList: '/feather/zzjg/getZzjgs',
        // 新增院系负责人
        addYxFzrSave: '/feather/fzr/save',
        // 删除负责人
        delFzr: '/feather/fzr/delById',
        // 根据类型(班级grade  专业major  系部dept)id查询用户
        typeIdQueryUser: '/feather/fzr/findFzr',
        // 查询所有专业列表（树形表格）
        queryAllZyList: '/feather/bxzy/getBxzyTree',
        // 分页查询行政班信息
        pagingQueryXzbInfo: '/feather/xzbsz/getXzbs',
    },
    // 权限行政班
    xzbPermission: {
        // 获取所有院系信息
        getYxxxes: '/feather/xzbPermission/getYxxxes',
        // 分页查询专业信息
        findPageBxzy: '/feather/xzbPermission/findPageBxzy',
        // 分页查询行政班信息
        findPageXzb: '/feather/xzbPermission/findPageXzb',
        // 分页查询学生信息
        findPageStudent: '/feather/xzbPermission/findPageStudent',
    },
    lcgl: {
        // 分页查询流程模板
        pagingQueryLcmb: 'workflow/lcmb/findPage',
        // 保存或修改流程模板
        saveOrEdit: '/workflow/lcmb/save',
        // 查询所有流程模板（下拉框）
        getAllLcmb: '/workflow/lcmb/getAll',
        // 分页查询流程节点
        pagingQueryLcNode: '/workflow/lcjd/findPage',
        // 保存或修改流程模板
        saveOrEditLcjd: '/workflow/lcjd/saveOrUpdate',
        // 根据ID删除当前节点下的审核人
        delJdShr: '/workflow/lcjd/deleteById',
        // 根据流程节点查询节点审核人
        // queryJdshr: '/feather/lcjdshr/findPage',
        // 获取所有审核人
        // getAllShrList: '/feather/teacher/getAllShr',
        // 新增流程节点审核人
        // addLcNodeShr: '/feather/lcjdshr/saveOrUpdate',
        // 删除当前节点下的审核人
        // deleteCurrentNodeShr: '/feather/lcjdshr/deleteByShr',
        // 分页查询流程模板业务关联
        pagingQueryYwGl: '/feather/lcmbywgl/findPage',
        // 获取所有业务类型（select）
        getAllYwType: '/workflow/sjzd/findBySjzd',
        // 获取所有流程模板（select）
        // getAllLcTmp: '/feather/lcmb/getAll',
        // 保存或修改模板业务关联
        tmpYwGlSaveOrEdit: '/feather/lcmbywgl/saveOrUpdate',
        // 根据id删除模板业务关联
        delMbywgl: '/feather/lcmbywgl/deleteById',
    },
    /**
     * 领导类型
     */
    ldlxUrls: {
        // 保存领导类型
        saveLdlx: 'workflow/ldlx/save',
        // 分页查询领导类型
        queryLdlx: 'workflow/ldlx/findPage',
        // 启用/禁用领导类型
        updEnable: 'workflow/ldlx/updEnable',
        // 查询所有领导类型
        getAll: '/workflow/ldlx/getAll',
    },
    teacherLdlx: {
        // 分页查询教师领导类型
        findPage: '/workflow/teacherLdlx/findPage',
        // 查询所有教师领导类型
        getAll: '/workflow/teacherLdlx/getAll',
        // 新增教师领导类型
        save: '/workflow/teacherLdlx/save',
        // 删除教师领导类型
        delete: '/workflow/teacherLdlx/delete',
        // 根据教师领导类id型查询
        getByLdlxid: '/workflow/teacherLdlx/getByLdlxid',
    },
    teacherFldlx: {
        // 分页查询教师领导
        findPage: '/workflow/teacherFldlx/findPage',
        // 新增修改教师领导
        saveOrUpdate: '/workflow/teacherFldlx/saveOrUpdate',
        // 删除教师领导
        delete: '/workflow/teacherFldlx/delete',
    },
    files: {
        // 上传头像文件
        uploadFile_icon: '/file/files/uploadFile_icon',
        // 下载头像文件
        downloadFile_icon: '/file/files/downloadFile_icon',
        uploadApk: '/file/files/uploadApk',
        downloadApk: '/file/files/downloadApk',
        deleteApk: '/file/files/deleteApk',
    },
    // 分页查询字典数据
    pagingZDdata: '/feather/field/getFields',
    // 保存或修改数据字典信息
    addOrEditZDInfo: '/feather/field/save',
    // 启用或禁用数据字典
    enableZDData: '/feather/field/isEnable',
    // 根据id删除数据字典信息
    deleteZdInfo: '/feather/field/delById',
    // 查询系统更新日志
    queryUpdateLog: '/feather/doc/updateLogger',
    // 获取模块名称信息集合
    getModuleNames: '/log/log/getModuleNames',
    // 查询操作日志信息
    findLogPage: '/log/log/findPage',
    // 分页查询第三方请求日志
    thirdlogFindPage: '/log/thirdlog/findPage',

    // 备份管理
    backupUrl: {
        // 数据库备份配置保存
        dbSave: '/backup/dqbfpz/save',
        // 获取数据库备份配置
        dbGetDqbfpz: '/backup/dqbfpz/getDqbfpz',
        // 获取数据库备份的时间
        dbGetAllAccessDates: '/backup/dqbfjl/getAllAccessDates',
        // 数据库备份恢复接口
        dbRecovery: '/backup/dqbfjl/recovery',
        //查询备份记录
        dbFindPage: '/backup/dqbfjl/findPage',

        // 文件备份配置保存
        fileSave: '/backup/wjbfpz/save',
        // 获取文件备份配置
        fileGetWjbfpz: '/backup/wjbfpz/getWjbfpz',
        // 获取文件备份成功的时间集合
        fileGetAllAccessDates: '/backup/wjbfjl/getAllAccessDates',
        // 文件备份恢复
        fileRecovery: '/backup/wjbfjl/recovery',
        //查询备份记录
        fileFindPage: '/backup/wjbfjl/findPage',

        //临时备份查询
        lsFindPage: '/backup/lsbfjl/findPage',
        //查询备份的模块
        getBackupModles: '/backup/lsbfmk/getBackupModles',
        //临时备份
        lsbackup: '/backup/lsbfmk/backup',
        //临时备份恢复
        lsRecovery: '/backup/lsbfmk/recovery',

    },
    /**
     * 版本管理url
     */
    bbglUrls: {
        // 查询模块树
        getModles: '/deploylog/deployModle/getModles',
        // 分页查询模块分支版本信息
        findPage: '/deploylog/modleBranchVersion/findPage',
        // 更新所有新部署的模块
        upgradeAll: '/deploylog/modleBranchVersion/upgradeAll',
        // 保存模块分支版本信息
        save: '/deploylog/modleBranchVersion/save',
        // 版本失效
        invalidate: '/deploylog/modleBranchVersion/invalidate',
        // 删除所有失效数据
        delAllInvalidate: '/deploylog/modleBranchVersion/delAllInvalidate',
    },
    /**
     * 模块管理urls
     */
    deployModleUrls: {
        // 查询所有模块
        getAllModles: '/deploylog/deployModle/getAllModles',
        // 查询模块下所有的分支
        getAllBranchs: '/deploylog/deployModle/getAllBranchs',
    },
    /**
     * 学校信息维护url
     */
    schoolUrls: {
        // 保存学校信息
        save: '/deploylog/school/save',
        // 修改学校的启用状态
        updEnable: '/deploylog/school/updEnable',
        // 分页查询学校信息
        findPage: '/deploylog/school/findPage',
        // 查询全部学校信息
        getAll: '/deploylog/school/getAll',
    },
    /**
     * 学校模块分支url
     */
    schoolModleBranchUrls: {
        // 查询学校所有没有添加的模块
        getAllNotAddModles: '/deploylog/schoolModleBranch/getAllNotAddModles',
        // 保存学校模块分支
        save: '/deploylog/schoolModleBranch/save',
        // 添加所有没添加过的模块分支
        saveAll: '/deploylog/schoolModleBranch/saveAll',
        // 分页查询学校模块分支
        findPage: '/deploylog/schoolModleBranch/findPage',
        // 查询学校的所有模块
        getAllSchoolModles: '/deploylog/schoolModleBranch/getAllSchoolModles',
        // 查询学校模块下的所有分支
        getAllSchoolModleBranchs: '/deploylog/schoolModleBranch/getAllSchoolModleBranchs',
    },
    /**
     * 部署管理urls(管理端使用)
     */
    deployMangageUrls: {
        // 分页查询学校模块分支版本信息
        findPageSchoolModleBranchVersion: '/deploylog/schoolModleBranchVersion/findPageSchoolModleBranchVersion',
        // 部署一个
        deployOne: '/deploylog/deployServer/deployOne',
        // 部署多个
        deployAll: '/deploylog/deployServer/deployAll',
        // 查询学校模块所有可用版本
        getAllSchoolModleBranchAvailableVersions: '/deploylog/schoolModleBranchVersion/getAllSchoolModleBranchAvailableVersions',
        // 服务端分页查询学校部署记录
        findPage: '/deploylog/schoolDeployLog/findPage',
    },
    /**
     * 升级管理urls
     */
    upgradeManageUrls: {
        // 学校查询所有模块
        getAllModles: '/deploylog/upgradeManagement/getAllModles',
        // 学校分页查询发布的模块分支版本信息
        findPageModleBranchVersion: '/deploylog/upgradeManagement/findPageModleBranchVersion',
        // 学校查询模块所有可用版本
        getAllModleBranchAvailableVersions: '/deploylog/upgradeManagement/getAllModleBranchAvailableVersions',
        // 分页查询部署日志
        findPageDeploylog: '/deploylog/upgradeManagement/findPageDeploylog',
        // 部署一个
        deployOne: '/deploylog/upgradeManagement/deployOne',
        // 部署多个
        deployAll: '/deploylog/upgradeManagement/deployAll',
    },
};
